"use strict";

var _regeneratorRuntime = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var firestore_1 = require("firebase/firestore");

var functions_1 = require("firebase/functions");

var firebase_1 = require("../../config/firebase");

var Model_1 = __importDefault(require("../Model"));

var Espace = /*#__PURE__*/function (_Model_1$default) {
  _inherits(Espace, _Model_1$default);

  var _super = _createSuper(Espace);

  function Espace(props) {
    _classCallCheck(this, Espace);

    return _super.call(this, _objectSpread({
      collectionName: 'boutiques',
      orderDirection: 'asc',
      orderField: 'name',
      title: 'name'
    }, props));
  }

  _createClass(Espace, [{
    key: "secureUpdate",
    value: function secureUpdate(values) {
      return {
        algoliaAppId: values.algoliaAppId,
        algoliaIndexName: values.algoliaIndexName,
        algoliaSearchKey: values.algoliaSearchKey,
        channels: values.channels,
        commandeMailSujet: values.commandeMailSujet,
        commandeMailText: values.commandeMailText,
        conditionByDefault: values.conditionByDefault,
        coordinates: values.coordinates,
        createdAt: values.createdAt,
        demandeMailSujet: values.demandeMailSujet,
        demandeMailText: values.demandeMailText,
        demandeReponseAuto: values.demandeReponseAuto,
        domainAssetsURL: values.domainAssetsURL,
        fromMail: values.fromMail,
        fromName: values.fromName,
        isInStoreByDefault: values.isInStoreByDefault,
        isOnlineStoreByDefault: values.isOnlineStoreByDefault,
        langues: values.langues,
        name: values.name,
        optionPriceByDefault: values.optionPriceByDefault,
        originUrls: values.originUrls,
        prices: values.prices,
        productCategories: values.productCategories,
        productCollections: values.productCollections,
        productTemplates: values.productTemplates,
        responseMail: values.responseMail,
        shippingModeByDefault: values.shippingModeByDefault,
        smtpPassword: values.smtpPassword,
        smtpServer: values.smtpServer,
        smtpUsername: values.smtpUsername,
        storageBucketPath: values.storageBucketPath,
        updatedAt: (0, dayjs_1.default)().toISOString(),
        websiteURL: values.websiteURL
      };
    }
  }, {
    key: "search",
    value: function search(q) {
      var search = (0, functions_1.httpsCallable)(firebase_1.functions, 'search');
      return search({
        q: q
      }).then(function (result) {
        return result.data;
      });
    }
  }], [{
    key: "searchFeatures",
    value: function () {
      var _searchFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(espaceId, collectionName) {
        var order,
            ref,
            constraints,
            q,
            querySnapshot,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                order = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'datetime';
                ref = (0, firestore_1.collection)(firebase_1.firestore, 'boutiques', espaceId, collectionName);
                constraints = [(0, firestore_1.where)('deleted', '==', false), (0, firestore_1.orderBy)(order)];
                q = (0, firestore_1.query).apply(void 0, [ref].concat(constraints));
                _context.next = 6;
                return (0, firestore_1.getDocs)(q);

              case 6:
                querySnapshot = _context.sent;
                return _context.abrupt("return", querySnapshot.docs.map(function (d) {
                  return _objectSpread({
                    id: d.id
                  }, d.data());
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function searchFeatures(_x, _x2) {
        return _searchFeatures.apply(this, arguments);
      }

      return searchFeatures;
    }()
  }]);

  return Espace;
}(Model_1.default);

exports.default = Espace;